import React, { Component } from 'react';

import Constants from '../Constants';

import '../styles/ScoreChart.css';

// The points a word earns by its length, read straight off the score table so
// the rules cannot drift from what the board actually scores. It stops at the
// longest word a daily can hold: seven cells, three of them expanded. Two rows
// rather than a line per length, since it sits in a narrow column.
class ScoreChart extends Component {
  render() {
    const lengths = [];
    for (let length = Constants.MINIMUM_WORD_LENGTH; length <= Constants.SCORE_CHART_MAX_LENGTH; length++) {
      lengths.push(length);
    }

    return (
      <table className="score-chart">
        <tbody>
          <tr>
            <th scope="row">Letters</th>
            { lengths.map((length) => <td key={length}>{length}</td>) }
          </tr>
          <tr>
            <th scope="row">Points</th>
            { lengths.map((length) => <td key={length}>{Constants.SCORE_TABLE[length]}</td>) }
          </tr>
        </tbody>
      </table>
    );
  }
}

export default ScoreChart;
